/**
 * Brand-level constants that a rename has to be able to change in ONE place.
 *
 * "MyCIO" is a registered mark held by someone else, so this product is going to be renamed (PrivateCIO is
 * the current pick, not yet secured). When that happens the support address changes with the domain — and
 * it is quoted in the Refund Policy and Terms, which are binding text in 15 languages. Hard-coding it there
 * meant a rename would require editing ~78 strings, most of them legal copy, with no way to verify none had
 * been missed. One constant means one edit and a grep that proves it.
 *
 * NEXT_PUBLIC_* is inlined at BUILD time, so changing it needs a rebuild, not just a restart. That is the
 * right trade here: this value appears in statically-rendered legal pages, and a runtime lookup would mean
 * the policy text could differ between the server render and the client hydration.
 */
export const SUPPORT_EMAIL = process.env.NEXT_PUBLIC_SUPPORT_EMAIL || 'support@mycio.ai'
